import { ReactComponent as Logo } from './icons/logo.svg'
import { ReactComponent as LogoBlack } from './icons/logo-black.svg'

function SparxLogo({ height = 'auto', width = '100px', mode = 'dark' }) {
  return <div style={{ height, width: height ? 'auto' : width }}>{mode === 'dark' ? <LogoBlack /> : <Logo />} </div>
}

export default SparxLogo
